module.exports = __webpack_public_path__ + "static/media/hero_bg_desktop.fcfe5e09.png";